var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWatchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .813A9.686 9.686 0 0 0 .312 10.5 9.686 9.686 0 0 0 10 20.188a9.686 9.686 0 0 0 9.688-9.688A9.686 9.686 0 0 0 10 .812Zm0 17.5A7.786 7.786 0 0 1 2.187 10.5c0-4.297 3.477-7.813 7.813-7.813 4.297 0 7.813 3.516 7.813 7.813 0 4.336-3.516 7.813-7.813 7.813Zm2.383-4.063c.234.156.508.117.664-.117l.742-.977c.156-.234.117-.508-.117-.664l-2.578-1.914V5.031a.504.504 0 0 0-.469-.468h-1.25a.475.475 0 0 0-.469.468v6.446c0 .117.04.273.156.351l3.32 2.422Z",
    fill: "#B1B2BF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWatchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/watch-icon.4e31a6793d3f7eb93fe37327f9b11028.svg";